import { render } from "./LoteFreteRepeticao.vue?vue&type=template&id=6ddac2f5&scoped=true"
import script from "./LoteFreteRepeticao.vue?vue&type=script&lang=js"
export * from "./LoteFreteRepeticao.vue?vue&type=script&lang=js"

import "./LoteFreteRepeticao.vue?vue&type=style&index=0&id=6ddac2f5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddac2f5"]])

export default __exports__